<!--顶部工具栏组件-->
<template>
  <v-toolbar id="core-toolbar" class="toolbar">
    <div class="head">
      <div class="logo">
        <img src="@/assets/bayer-logo.png" />
      </div>
      <div class="logo-title">SMS Monitoring Portal</div>
    </div>

    <v-spacer />

    <div>
      <span class="user-cell">{{ userName }}</span>
    </div>

    <v-badge>
      <v-icon @click="logoff()" class="user-avatar">$powerStandby</v-icon>
    </v-badge>
  </v-toolbar>
</template>
<style>
.head {
  height: 72px;
  background: transparent;
  left: 0px;
  top: 0px;
  width: 60%;
}
.user-cell {
  color: white;
  font-size: 16px;
  margin-right: 20px
}
.user-avatar{
  color: white !important;
}
.toolbar {
  background-color: #0071ba !important;
  height: 72px !important;
  position: fixed !important;
  width: 100% !important;
  z-index: 10 !important;
}
</style>
<script>
import { mapState } from 'vuex'

export default {
  data: () => ({}),
  computed: {
    ...mapState({
      base: (state) => state.base,
    }),
    userName() {
      return this.base.user.name
    },
  },
  mounted: function () {},
  methods: {
    logoff() {
      this.base.user = null
      this.$msal.signOut()
    },
  },
}
</script>

<style>
#core-toolbar a {
  text-decoration: none;
}
.v-toolbar {
  box-shadow: none !important;
  z-index: 4;
}
.v-toolbar__content {
  height: 72px !important;
}
.logo {
  width: 69px;
  height: 69px;
  margin-left: 9px;
  float: left;
}
.logo img {
  margin-top: -1px;
  width: 69px;
  height: 69px;
}
.logotitle {
  float: left;
  padding: 21px 20px 10px 30px;
  font-size: 19px;
  color: white;
}
.logo-title {
  float: left;
  padding: 21px 10px 10px 30px;
  font-size: 19px;
  color: white;
}
</style>
